import React, { useEffect } from "react";
import { MeshTransmissionMaterial } from "@react-three/drei";
import { useControls, folder } from "leva";
import { Color, DoubleSide } from "three";
import { ModelProps } from "./Model";
import { usePerfManager } from "@/features/performance/PerfManager";

export function Bottle({ nodes, textures }: ModelProps) {
  const { perfState, isMonitorActive, settings } = usePerfManager();

  // Destructure as an array to get the 'set' function
  const [config, set] = useControls(
    "Bottle",
    () => ({
      Show: true,
      Material: folder(
        {
          meshPhysicalMaterial: false,
          backside: false,
          wireframe: false,
          roughness: { value: 0.0, min: 0, max: 1, step: 0.01 },
          clearcoat: { value: 1, min: 0, max: 1 },
        },
        { collapsed: true }
      ),

      Transmission: folder(
        {
          transmission: { value: 1, min: 0, max: 1 },
          transmissionSampler: false,
          samples: { value: 3, min: 1, max: 32, step: 1 },
          resolution: { value: 2048, min: 256, max: 2048, step: 256 },
          thickness: { value: 0.10, min: 0, max: 2, step: 0.01 },
          ior: { value: 1.5, min: 1, max: 5, step: 0.01 },
          attenuationDistance: { value: 0.5, min: 0, max: 10, step: 0.01 },
          attenuationColor: "#ffffff",
        },
        { collapsed: true }
      ),

      Distortion: folder(
        {
          chromaticAberration: { value: 0.06, min: 0, max: 1 },
          anisotropy: { value: 0.1, min: 0, max: 1, step: 0.01 },
          distortion: { value: 0.0, min: 0, max: 1, step: 0.01 },
          distortionScale: { value: 0.3, min: 0.01, max: 1, step: 0.01 },
          temporalDistortion: { value: 0.5, min: 0, max: 1, step: 0.01 },
        },
        { collapsed: true }
      ),

      Appearance: folder(
        {
          color: "#ffffff",
          bg: "#ffffff",
        },
        { collapsed: true }
      ),
    }),
    { collapsed: true },
    [perfState]
  );

  // performance
  useEffect(() => {
    if (!isMonitorActive) return;
    set({
      samples: settings.bottle.samples,
      anisotropy: settings.bottle.anisotropy,
      chromaticAberration: settings.bottle.chromaticAberration,
      temporalDistortion: settings.bottle.temporalDistortion,
      clearcoat: settings.bottle.clearcoat, // Added here
    });
  }, [perfState, set, isMonitorActive, settings]);

  if (!config.Show) return;
  return (
    <mesh
      name="Bottle"
      castShadow
      receiveShadow
      geometry={nodes.Bottle.geometry}
    >
      <MeshTransmissionMaterial
        // roughnessMap={textures.rough}
        normalMap={textures.normals}
        background={new Color(config.bg)}
        {...config}
      />
    </mesh>
  );
}
